import React from 'react';
import { apiHolder } from 'api';
import classnames from 'classnames';
import { navigate } from '@reach/router';
import { message, Popover } from 'antd';
import Button from '@web-common/components/UI/Button';
import UnionIcon from '@/images/icons/edm/union-icon.svg';
import { handlePreviewImage } from '../../utils';
import styles from './MailTemplateListV2.module.scss';
import { getTaskContent } from './template-util';
import { setTemplateContent } from '../template-util';
import { edmDataTracker } from '../../tracker/tracker';
const systemApi = apiHolder.api.getSystemApi();
const routerWord = systemApi.isWebWmEntry() ? '#intelliMarketing' : '#edm';
export const TaskCard = ({ task, addNewTemplate, isFormWrite, onUse, isFromModal }) => {
    const useTaskAsTemplate = async (id) => {
        try {
            const content = await getTaskContent(id);
            if (isFormWrite && !isFromModal) {
                onUse && onUse('', content, 'task');
            }
            else {
                setTemplateContent(content);
                navigate(`${routerWord}?page=write&from=template`);
            }
        }
        catch (err) {
            message.error('获取任务详情失败，请稍后重试！');
        }
    };
    const saveTaskAsTemplate = async (id) => {
        edmDataTracker.templatePageOp('save', 'task');
        try {
            const content = await getTaskContent(id);
            addNewTemplate && addNewTemplate(content);
        }
        catch (err) {
            message.error('获取任务详情失败，请稍后重试！');
        }
    };
    const renderImg = () => {
        var _a;
        const images = (task.thumbnail || '').split(',');
        return React.createElement("img", { src: (_a = images[1]) !== null && _a !== void 0 ? _a : images[0], alt: "" });
    };
    const renderCardOp = () => {
        if (isFromModal) {
            return (React.createElement(Button, { className: classnames(styles.templateBtn, styles.templateBtn2), style: {
                    width: 74,
                    height: 28,
                }, btnType: "primary", onClick: () => useTaskAsTemplate(task.edmEmailId) }, "\u4F7F\u7528"));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Popover, { title: null, trigger: "click", getPopupContainer: node => node, placement: "topLeft", zIndex: 10, content: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.popoverContent },
                        React.createElement("div", { className: classnames(styles.popoverBtn), onClick: () => saveTaskAsTemplate(task.edmEmailId) }, "\u4FDD\u5B58\u4E3A\u4E2A\u4EBA\u6A21\u677F"))) },
                React.createElement("div", { className: styles.popoverWrap },
                    React.createElement("img", { src: UnionIcon, alt: "" }))),
            !isFormWrite && (React.createElement(Button, { className: styles.templateBtn, style: {
                    width: 74,
                    height: 28,
                }, onClick: () => {
                    edmDataTracker.templatePageOp('viewTask', 'task');
                    navigate(`${routerWord}?page=index&detailId=${task.edmEmailId}`);
                }, btnType: "minorLine" }, "\u67E5\u770B\u4EFB\u52A1")),
            React.createElement(Button, { className: styles.templateBtn, style: {
                    width: 74,
                    height: 28,
                }, btnType: "primary", onClick: () => useTaskAsTemplate(task.edmEmailId) }, "\u4F7F\u7528")));
    };
    return (React.createElement("div", { className: styles.taskItem },
        React.createElement("div", { className: classnames(styles.taskCard, isFormWrite ? styles.taskCardMin : '') },
            React.createElement("div", { className: classnames(styles.taskCardTitle, styles.ellipsis) }, task.edmSubject),
            React.createElement("div", { className: styles.taskCardImg, onClick: () => {
                    edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                        type: 'preview',
                    });
                    handlePreviewImage(task.thumbnail, task.edmSubject);
                } }, renderImg()),
            React.createElement("div", { className: styles.labels },
                task.readRatio != null && React.createElement("div", { className: styles.labelItem },
                    "\u6253\u5F00\u7387: ",
                    task.readRatio),
                task.replyRatio != null && React.createElement("div", { className: styles.labelItem },
                    "\u56DE\u590D\u7387: ",
                    task.replyRatio)),
            React.createElement("div", { className: classnames(styles.cardOp, isFormWrite ? styles.cardOpMin : '') }, renderCardOp())),
        React.createElement("div", { className: styles.taskTime },
            "\u521B\u5EFA\u65F6\u95F4\uFF1A",
            task.createTime)));
};
